export default __webpack_public_path__ + "static/media/arrow_drop_down.a192b6ce.svg";